import httpManager from "@/app/shared/utils/httpManager";

export async function deleteWorkTeam() {
  await httpManager.delete("/settings/customer/delete/");
}
